import React from 'react';

const PersistentMiniEpgArrow = ({ type = '', src }) => {
    return (
        <div className={`mini-arrow-${type}`}>
            <img className="mini-arrow-image" src={src} alt="arrow"/>
            {/* <i className={`fa fa-chevron-${type}`}/> */}
        </div>
    );
};

export default PersistentMiniEpgArrow;



// WEBPACK FOOTER //
// ./src/components/PersistentMiniEpg/PersistentMiniEpgArrow.jsx